
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import CircularProgressBar from '../../../common/CircularProgressBar';
import { getNumberOfWeeksInAYear, getWeeksBetweenDates } from '../../../utils/date';

function ActivityTrackerV3(props) {
    const [thisWeek, setThisWeek] = useState(0);
    const [last7Days, setLast7Days] = useState(0);
    const [streak, setStreak] = useState(0);

    const { allWorkoutHistoryWithArchived, user } = props.User;

    console.log("allWorkoutHistoryWithArchived", allWorkoutHistoryWithArchived);

    useEffect(async () => {
        let completed = [];
        let last7DaysTemp = [];

        if (allWorkoutHistoryWithArchived.length) {
            const lastWeekDate = new Date(moment(new Date()).subtract(7, "days").format("L"));

            for (let x = 0; x < allWorkoutHistoryWithArchived.length; x++) {
                if (allWorkoutHistoryWithArchived[x].percentage >= 80) {
                    completed.push(allWorkoutHistoryWithArchived[x])


                    if (new Date(allWorkoutHistoryWithArchived[x].created_at) >= lastWeekDate) {
                        last7DaysTemp.push(allWorkoutHistoryWithArchived[x])
                    }
                }
            }

            setLast7Days(last7DaysTemp);

            completed = completed.sort((a, b) => {
                return new Date(a.created_at) - new Date(b.created_at);
            });

            const allWeeks = getWeeksBetweenDates(completed[0]?.created_at);
            const groups = await completed.reduce((acc, woh) => {

                let d = moment(woh.created_at);

                // create a composed key: 'year-week' 
                const yearWeek = `${d.year()}-${(d.week() + "").padStart(2, "0")}`;

                // add this key as a property to the result object
                if (!acc[yearWeek]) {
                    acc[yearWeek] = [];
                }

                // push the current date that belongs to the year-week calculated befor
                acc[yearWeek].push(d.format('L'));

                return acc;

            }, {});

            let curWeekNo = moment(new Date()).week(), wk;
            console.log("allWeeks", allWeeks);

            console.log("groups", groups);
            // const keys = Object.keys(groups).sort().reverse();
            const keys = allWeeks;

            const currentDay = moment(new Date());
            const currentWeek = `${currentDay.year()}-${(currentDay.week() + "").padStart(2, "0")}`
            let streakTmp = 0;
            for (let x = 0; x < keys?.length; x++) {
                wk = Number(keys[x]?.split("-")[1])
                if (wk != curWeekNo) {

                    if (groups[keys[x]]?.length > 2) {
                        streakTmp++;
                    } else {
                        break;
                    }
                }

            }
            setStreak(streakTmp);

            const count = groups[currentWeek]?.length || 0;
            setThisWeek(count)
            props?.setWeekProgress(count);
        }


    }, [allWorkoutHistoryWithArchived]);

    return (
        <div id="activity-tracker" className='at-v2 stats'>
            <h5 className='section-header'>YOUR PROGRESS</h5>

            <div>
                <div className='at-v2-card'>
                    <div className='custom-cpb-container'>
                        <CircularProgressBar value={thisWeek} max={3} trailColor="#E4E4E4" separatorColor="#fff" />
                    </div>
                    <div className="activity-card-details">
                        <h5>THIS WEEK</h5>
                        <p>Complete your circle by finishing three workouts each week.</p>
                    </div>
                </div>

                <div className='at-v2-card'>
                    <div className='custom-cpb-container'>

                        <h1>{streak}</h1>
                        <h6>WEEKS</h6>
                    </div>
                    <div className="activity-card-details">
                        <h5>STREAK</h5>
                        <p>Add to your streak every week you complete 3 workouts</p>
                    </div>
                </div>

            </div>

        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
})(ActivityTrackerV3);